import { render, staticRenderFns } from "./AppCellsGrid.vue?vue&type=template&id=28cbeedd&scoped=true&"
import script from "./AppCellsGrid.vue?vue&type=script&lang=js&"
export * from "./AppCellsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AppCellsGrid.vue?vue&type=style&index=0&id=28cbeedd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cbeedd",
  null
  
)

export default component.exports